import { useMessage } from 'framework/hooks/web/useMessage'
import { useIntervalFn } from '@vueuse/core'

export async function checkUpdate({ pause, isActive }) {
  console.log('检查更新', location)
  const { createConfirm } = useMessage()

  try {
    // 检测前端资源是否有更新
    const response = await fetch(`${location.origin}/version/versionData.json`, {
      headers: {
        'Cache-Control': 'no-cache',
      },
    }).then((res) => res.json())

    console.log('response', response, `${location.origin}/version/versionData.json`)

    if (!localStorage.getItem('v3_version')) {
      localStorage.setItem('v3_version', response.version)
    } else {
      if (localStorage.getItem('v3_version') !== response.version) {
        console.log('弹窗更新版本')
        // 增加一个全局变量用于标记弹窗状态，防止重复弹窗
        if ((window as any).__version_update_modal_open__) {
          return
        }
        ;(window as any).__version_update_modal_open__ = true
        createConfirm({
          title: `系统检测到有新版本发布`,
          content: '是否立即更新？',
          iconType: 'warning',
          onOk: () => {
            localStorage.setItem('v3_version', response.version)
            window.location.reload()
          },
          onCancel: () => {
            if (isActive) {
              pause()
            } // 暂停定时器
            ;(window as any).__version_update_modal_open__ = false
          },
        })
      }
    }
  } catch (e) {
    return Promise.reject(e)
  }
}
/**
 * @description 初始化版本检测器
 */
export function useCheckVersion() {
  const { pause, resume, isActive } = useIntervalFn(
    () => {
      checkUpdate({ pause, isActive })
    },
    600000,
    { immediate: true },
  )
  return {
    pause,
    resume,
    isActive,
  }
}
